import { BOARD_TYPE } from './server/constants';

import type { FlightEntryData } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ArrivalsDepartures';
import type { LocalisationHelpers } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

export type Board = (typeof BOARD_TYPE)[keyof typeof BOARD_TYPE];

interface State {
  arrivalsList: FlightEntryData[];
  arrivalsLoading: boolean;
  currentPage: number;
  departuresList: FlightEntryData[];
  departuresLoading: boolean;
  error: boolean;
  freeTextSearch: string;
  localisation: Partial<LocalisationHelpers>;
  pageSize: number;
  selectedBoard: Board;
}

type Action =
  | { type: 'changePage'; payload: number }
  | { type: 'selectEntry'; payload: FlightEntryData }
  | { type: 'freeTextSearch'; payload: string }
  | { type: 'clearSearchValue' }
  | { type: 'clearError' }
  | { type: 'searchValue'; payload: string }
  | { type: 'localisation'; payload: LocalisationHelpers }
  | { type: 'arrivalsLoading' }
  | { type: 'arrivalsLoaded'; payload: FlightEntryData[] }
  | { type: 'departuresLoading' }
  | { type: 'departuresLoaded'; payload: FlightEntryData[] }
  | { type: 'changeBoard'; payload: Board }
  | { type: 'error' };

export const ArrivalsDeparturesBoardInitialState: State = {
  arrivalsList: [],
  arrivalsLoading: true,
  currentPage: 0,
  departuresList: [],
  departuresLoading: false,
  error: false,
  freeTextSearch: '',
  pageSize: 20,
  selectedBoard: BOARD_TYPE.ARRIVALS,
  localisation: {},
};

export function ArrivalsDeparturesBoardReducer(state: State, action: Action) {
  switch (action.type) {
    case 'changePage':
      return {
        ...state,
        currentPage: action.payload,
      };
    case 'freeTextSearch':
      return {
        ...state,
        freeTextSearch: action.payload,
      };
    case 'clearSearchValue':
      return {
        ...state,
        freeTextSearch: '',
      };
    case 'clearError':
      return {
        ...state,
        error: false,
      };
    case 'arrivalsLoading':
      return {
        ...state,
        arrivalsLoading: true,
      };
    case 'arrivalsLoaded':
      return {
        ...state,
        arrivalsList: action.payload,
        arrivalsLoading: false,
      };
    case 'departuresLoading':
      return {
        ...state,
        departuresLoading: true,
      };
    case 'departuresLoaded':
      return {
        ...state,
        departuresList: action.payload,
        departuresLoading: false,
      };
    case 'localisation':
      return {
        ...state,
        localisation: action.payload,
      };
    case 'changeBoard':
      return {
        ...state,
        currentPage: 0,
        selectedBoard: action.payload,
      };
    case 'error':
      return {
        ...state,
        error: true,
        arrivalsLoading: false,
        departuresLoading: false,
      };
    default:
      return state;
  }
}
